

// Generic Model Reducers
import { DefaultModelReducers, modelActionName } from '../../../../redux/DefaultModelReducers';
import { clearActionType, failedActionType, loadingActionType, successActionType, wipeActionType } from '../../../../redux/utils'


// Extra Options
const otherReducers = (model, state, action) => {
    switch (action.type) {
        case modelActionName(model, 'Download'):
        case failedActionType(modelActionName(model, 'Download')):
        case clearActionType(modelActionName(model, 'Download')):
        case successActionType(modelActionName(model, 'Download')):
            return Object.assign({}, state, { ...action.payload })

    }
    return false;
}


// Generic Model Reducers
const defaults = DefaultModelReducers('Asset', otherReducers);
export default defaults;

// If we want to add more... make a new reducers and use combind
// const commentReducers = combineReducers({
//     defaults,
//     otherReducers
//   });